function normalizeSearchText(value) {
    return String(value || "").trim().toLowerCase()
}

export function isGoodsNameMatched(goodsItem, keyword) {
    const normalizedKeyword = normalizeSearchText(keyword)
    if (!normalizedKeyword || !goodsItem) return false

    return normalizeSearchText(goodsItem.goods_name).includes(normalizedKeyword)
}

export function prioritizeMatchedGoods(goodsList, keyword) {
    if (!Array.isArray(goodsList)) return []
    if (!normalizeSearchText(keyword)) return goodsList

    const matchedGoods = []
    const unmatchedGoods = []

    goodsList.forEach(goodsItem => {
        if (isGoodsNameMatched(goodsItem, keyword)) {
            matchedGoods.push(goodsItem)
        } else {
            unmatchedGoods.push(goodsItem)
        }
    })

    return matchedGoods.concat(unmatchedGoods)
}
